 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"banners":"banners","base~day~settingsReminders~subscription~userEdit~videoConsultation":"base~day~settingsReminders~subscription~userEdit~videoConsultation","base~day~subscription~userEdit":"base~day~subscription~userEdit","base~chat~homework~userEdit":"base~chat~homework~userEdit","base~userSettings":"base~userSettings","base":"base","subscription":"subscription","settingsReminders~videoConsultation":"settingsReminders~videoConsultation","settingsReminders":"settingsReminders","videoConsultation":"videoConsultation","calendar~chat~day~home~home-events~homework~user":"calendar~chat~day~home~home-events~homework~user","chat~homework~user":"chat~homework~user","chat~homework":"chat~homework","chat":"chat","homework":"homework","home~home-events":"home~home-events","home":"home","home-events":"home-events","calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations":"calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations","userEdit":"userEdit","userSettings":"userSettings","day":"day","calendar":"calendar","user":"user","homeworks":"homeworks","support":"support","videoConsultations":"videoConsultations","courseFreeze":"courseFreeze","linkSocialNetworks":"linkSocialNetworks","materials":"materials","password":"password","points":"points","pointsHistory":"pointsHistory","settingsCookiePolicy":"settingsCookiePolicy","settingsNotifications":"settingsNotifications","socialNetworks":"socialNetworks","subscriptions":"subscriptions","userSetting":"userSetting"}[chunkId]||chunkId) + "." + {"banners":"079b4a16","base~day~settingsReminders~subscription~userEdit~videoConsultation":"49809c9d","base~day~subscription~userEdit":"c19b57a1","base~chat~homework~userEdit":"b4caa9b3","base~userSettings":"6e7ee7c6","base":"92ccea85","subscription":"fd091faa","settingsReminders~videoConsultation":"3152e2c8","settingsReminders":"8990019b","videoConsultation":"6e1dab7a","calendar~chat~day~home~home-events~homework~user":"2ba711ae","chat~homework~user":"d1a3281e","chat~homework":"ee5911bb","chat":"568bc6d6","homework":"76727565","home~home-events":"eadc9c91","home":"6ce1d678","home-events":"f6c20f26","calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations":"0664ecd7","userEdit":"e1da9b2b","userSettings":"e169da18","day":"f13ea2ab","calendar":"96f4c322","user":"9ebfa0f1","homeworks":"96b8ce98","support":"9f72dc2c","videoConsultations":"1aa64b79","chunk-8549cd68":"3b31f94b","courseFreeze":"2e893d00","linkSocialNetworks":"968c1d4b","materials":"70124d38","password":"6fcde04a","points":"d9f9ed3e","pointsHistory":"91d550be","settingsCookiePolicy":"5c35715f","settingsNotifications":"aa388a96","socialNetworks":"84919e7d","subscriptions":"57663314","userSetting":"3acc0d44"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"banners":1,"base~day~settingsReminders~subscription~userEdit~videoConsultation":1,"base~day~subscription~userEdit":1,"base~userSettings":1,"base":1,"subscription":1,"settingsReminders~videoConsultation":1,"settingsReminders":1,"videoConsultation":1,"calendar~chat~day~home~home-events~homework~user":1,"chat~homework~user":1,"chat~homework":1,"chat":1,"homework":1,"home~home-events":1,"home":1,"home-events":1,"calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations":1,"userEdit":1,"userSettings":1,"day":1,"calendar":1,"user":1,"homeworks":1,"support":1,"videoConsultations":1,"chunk-8549cd68":1,"courseFreeze":1,"linkSocialNetworks":1,"materials":1,"password":1,"points":1,"pointsHistory":1,"settingsCookiePolicy":1,"settingsNotifications":1,"socialNetworks":1,"subscriptions":1,"userSetting":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"banners":"banners","base~day~settingsReminders~subscription~userEdit~videoConsultation":"base~day~settingsReminders~subscription~userEdit~videoConsultation","base~day~subscription~userEdit":"base~day~subscription~userEdit","base~chat~homework~userEdit":"base~chat~homework~userEdit","base~userSettings":"base~userSettings","base":"base","subscription":"subscription","settingsReminders~videoConsultation":"settingsReminders~videoConsultation","settingsReminders":"settingsReminders","videoConsultation":"videoConsultation","calendar~chat~day~home~home-events~homework~user":"calendar~chat~day~home~home-events~homework~user","chat~homework~user":"chat~homework~user","chat~homework":"chat~homework","chat":"chat","homework":"homework","home~home-events":"home~home-events","home":"home","home-events":"home-events","calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations":"calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations","userEdit":"userEdit","userSettings":"userSettings","day":"day","calendar":"calendar","user":"user","homeworks":"homeworks","support":"support","videoConsultations":"videoConsultations","courseFreeze":"courseFreeze","linkSocialNetworks":"linkSocialNetworks","materials":"materials","password":"password","points":"points","pointsHistory":"pointsHistory","settingsCookiePolicy":"settingsCookiePolicy","settingsNotifications":"settingsNotifications","socialNetworks":"socialNetworks","subscriptions":"subscriptions","userSetting":"userSetting"}[chunkId]||chunkId) + "." + {"banners":"f4c229e4","base~day~settingsReminders~subscription~userEdit~videoConsultation":"7e6bab60","base~day~subscription~userEdit":"3f3ca59e","base~chat~homework~userEdit":"31d6cfe0","base~userSettings":"8be85019","base":"f8f3c03e","subscription":"397642b7","settingsReminders~videoConsultation":"458f1677","settingsReminders":"a6ff1200","videoConsultation":"fd3bc8d8","calendar~chat~day~home~home-events~homework~user":"d30f2759","chat~homework~user":"c2e34a7d","chat~homework":"bae5e5ff","chat":"32f5f798","homework":"69f5bb9a","home~home-events":"c4dd8e30","home":"3854e17b","home-events":"4bc88973","calendar~day~homeworks~support~user~userEdit~userSettings~videoConsultations":"2fa45bef","userEdit":"7a8cb213","userSettings":"8560919f","day":"e2e326e7","calendar":"b9e1a1c0","user":"5e5e643e","homeworks":"186f4e35","support":"5d8273a1","videoConsultations":"4424757c","chunk-8549cd68":"eb379479","courseFreeze":"da590623","linkSocialNetworks":"3ddb4062","materials":"73319da3","password":"48d3370b","points":"900b6631","pointsHistory":"3c2bd015","settingsCookiePolicy":"9eeaf897","settingsNotifications":"c2aa52c4","socialNetworks":"d8944198","subscriptions":"fdd26f36","userSetting":"4f76252b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/v/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
